import React from "react";

function EmptyBox({ filename }) {
  return (
    <div className="card border-0 d-flex"style={{ height: "25rem", maxHeight: "20rem" }}>
      <div className="my-sm-5 py-sm-5 d-flex justify-content-center align-items-center flex-column">
        {/* <i class="display-1 bi bi-file-earmark-x"></i> */}
        <div className="mt-2 mb-1 font-style" style={{
          whiteSpace: "normal",
          // width: "100%",
          fontFamily:'Inter',
          fontWeight:400,
          color:'#000000'
        }}>{filename}</div>
      </div>
    </div>
  );
}

export default EmptyBox;
